var map = {
	"./App": 22,
	"./App.css": 22,
	"./Calendar": 20,
	"./Calendar.js": 20,
	"./Calendar.module": 3,
	"./Calendar.module.css": 3,
	"./Fonts": 11,
	"./Fonts.module": 11,
	"./Fonts.module.css": 11,
	"./Footer": 14,
	"./Footer.js": 14,
	"./Footer.module": 10,
	"./Footer.module.css": 10,
	"./Header": 13,
	"./Header.js": 13,
	"./Header.module": 7,
	"./Header.module.css": 7,
	"./Index": 19,
	"./Index.js": 19,
	"./Index.module": 1,
	"./Index.module.css": 1,
	"./Instagram": 16,
	"./Instagram.js": 16,
	"./Instagram.module": 8,
	"./Instagram.module.css": 8,
	"./Slider": 15,
	"./Slider.js": 15,
	"./Slider.module": 5,
	"./Slider.module.css": 5,
	"./Vars": 21,
	"./Vars.css": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;